// @flow

import React from 'react';
import { colors } from '../constants';

export type PlayIconProps = {
  width: number,
  height: number,
  color: string,
};

const PlayIcon = (props: PlayIconProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4369 10.0001L7.50006 4.2722L7.50006 15.728L15.4369 10.0001ZM16.8765 10.811C17.4295 10.4118 17.4295 9.58834 16.8765 9.1892L7.58527 2.48386C6.9239 2.00656 6.00006 2.47914 6.00006 3.29474L6.00006 16.7054C6.00006 17.521 6.9239 17.9936 7.58527 17.5163L16.8765 10.811Z"
      fill={props.color}
    />
  </svg>
);

PlayIcon.defaultProps = {
  color: colors.white,
  width: 20,
  height: 20,
};

export default PlayIcon;
